import Vue from 'vue';

import config from '@/utils/config';

const VueGoogleMaps = require('vue2-google-maps');
const { GmapMap } = require('vue2-google-maps/src/components/map.vue');
const { GmapMarker } = require('vue2-google-maps/src/components/marker');

Vue.component('GmapMap', GmapMap);
Vue.component('GmapMarker', GmapMarker);
Vue.use(VueGoogleMaps, {
  load: {
    key: config.getMapsAPIKey(),
    libraries: 'places',
  },
});
